import React from "react";

const Footer = () => {
  return (
    <section className="footer">
      <span className="disclaimer">
        © 2024 Designed & Developed by <span>Fauji</span>
      </span>
    </section>
  );
};

export default Footer;
